import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ApiConfiguration } from '@core/http-gen/api-configuration';
import { DestinatarioNotificaDto } from '@core/http-gen/models';

@Injectable({
    providedIn: 'root',
})
export class NotificaUploadService {
    constructor(
        private config: ApiConfiguration,
        private http: HttpClient,
    ) {}

    /**
     * Invia una notifica come multipart/form-data, formato atteso dall'endpoint
     * /api/notifica/invio-notifica (multer con campo file 'allegatoList').
     * Il client generato http-gen non è utilizzabile perché serializza il body come JSON
     * e gli allegati andrebbero persi.
     */
    public inviaNotifica(
        titolo: string,
        messaggio: string,
        destinatarioList: Array<DestinatarioNotificaDto>,
        allegatoList: Array<File>,
    ): Observable<void> {
        const formData: FormData = new FormData();
        formData.append('titolo', titolo ?? '');
        formData.append('messaggio', messaggio ?? '');
        formData.append('destinatarioList', JSON.stringify(destinatarioList ?? []));
        allegatoList?.forEach((file: File) => {
            formData.append('allegatoList', file, file.name);
        });

        return this.http.post<void>(this.config.rootUrl + '/api/notifica/invio-notifica', formData);
    }
}
